export const parseInitSettings = (data) => {
  const settings = data.user.settings;
  if (settings) return settings;
  return {
    explorer_view: {},
  };
};
